import captainInRideControls from "./captainInRideControls.component";

const captainInRideControlsModule = angular
  .module("app.components.captainInRideControls", [])
  .component("captainInRideControls", captainInRideControls);

export default captainInRideControlsModule;



// WEBPACK FOOTER //
// ./src/components/captainInRideControls/captainInRideControls.module.js